"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTokenNotBeforeError = void 0;
const common_1 = require("../common");
class AuthTokenNotBeforeError extends common_1.AuthError {
    constructor(notBeforeError) {
        super(notBeforeError.message);
        this.date = notBeforeError.date;
    }
}
exports.AuthTokenNotBeforeError = AuthTokenNotBeforeError;
//# sourceMappingURL=AuthTokenNotBeforeError.js.map